import { twMerge } from 'tailwind-merge';
import IconButton from '~/components/button/IconButton';
import type { Pagination } from './usePagination';

type PaginationControlsProps = Pagination & {
  className?: string;
  loop?: boolean;
};

export default function PaginationControls({
  currentPage,
  pageCount,
  next: onNext,
  hasNext,
  previous: onPrevious,
  hasPrevious,
  loop = false,
  className,
}: PaginationControlsProps) {
  if (pageCount < 2) return null;

  return (
    <nav
      aria-label="Pagination"
      className={twMerge('flex items-center body-md', className)}
    >
      <IconButton
        icon="ArrowLeft"
        aria-label="View Previous Page"
        className="border-none shadow-none"
        onClick={onPrevious}
        disabled={!loop && !hasPrevious}
      />
      <span className="w-24 text-center text-on-surface">
        {`${currentPage} / ${pageCount}`}
      </span>
      <IconButton
        icon="ArrowRight"
        aria-label="View Next Page"
        type="button"
        className="border-none shadow-none"
        onClick={onNext}
        disabled={!loop && !hasNext}
      />
    </nav>
  );
}
